import {
  HWSLandingPageRedirectionBrands,
  viewHotelWebsiteLink,
  hotelsSublink,
  reviewsSubLink,
  reviewsRedirectionVarValue,
} from '../../utils/constants';

/**
 * Custom hook to unify redirection links wherever possible.
 *
 * @param {string} brandCode Brand code of property to determine applicable redirection rule
 * @param {string} marshaCode Marsha code (propertyID) of the property
 * @param {string} propertyName Property name to construct redirection URL
 * @param {string} redirectionType Custom variable to determine redirection type
 * @param {string} locale Current locale of the property (optional arg)
 */

export function useRedirectionRules(
  brandCode: string,
  marshaCode: string,
  propertyName: string,
  redirectionType: string,
  locale?: string
) {
  let redirectionURL = '';
  if (redirectionType === reviewsRedirectionVarValue) {
    if (HWSLandingPageRedirectionBrands.includes(brandCode)) {
      redirectionURL =
        viewHotelWebsiteLink +
        marshaCode +
        '-' +
        propertyName
          ?.replace('-', ' ')
          ?.replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, '-')
          ?.replace(/^(-)+|(-)+$/g, '')
          ?.toLowerCase();
    } else {
      redirectionURL =
        '/' +
        locale +
        hotelsSublink +
        marshaCode +
        '-' +
        propertyName
          ?.replace('-', ' ')
          ?.replace(/([~!@#$%^&*()_+=`{}[\]|\\:;'<>,./? ])+/g, '-')
          ?.replace(/^(-)+|(-)+$/g, '')
          ?.toLowerCase() +
        reviewsSubLink;
    }
  }
  return redirectionURL;
}
